import { Image } from "./Image";
import { Intro } from "./Intro";
import { Title } from "./Title";
import { Video } from "./Video";

export const ArticleHeader = ({ content }) => {
  const layout = content.image_layout;
  const { heroVideo, intro, image } = content;

  return (
    <>
      <Title content={content} />

      {layout === "column" &&
        (heroVideo ? (
          <Video value={{ url: heroVideo, fallback: image }} />
        ) : (
          <Image value={image} width={1280} height={720} />
        ))}

      {intro && <Intro value={intro} />}
    </>
  );
};
